// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';
import { getSubUser } from './utils/auth';

function App() {
  return (
    <Router>
      <Routes>
        {/* เทียบกับ LoginActivity ที่เป็น LAUNCHER */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* เทียบกับ MainActivity */}
        <Route 
          path="/main" 
          element={
            getSubUser() != null ? <MainPage /> : <Navigate to="/login" replace />
          } 
        />
        
        {/* Redirect ไปที่ Login เป็นหน้าแรก */}
        <Route 
          path="/" 
          element={
            <Navigate to={getSubUser() != null ? "/main" : "/login"} replace />
          } 
        />
      </Routes>
    </Router>
  );
}

// ต้องมีบรรทัดนี้เพื่อ export default
export default App;